/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { LinkTelegramStartResponse, LinkTelegramStartVars } from '../openapi-types.gen.js';

export type { LinkTelegramStartResponse, LinkTelegramStartVars } from '../openapi-types.gen.js';

export const useLinkTelegramStart = createMutationHook<LinkTelegramStartVars, LinkTelegramStartResponse, unknown>({
  specName: 'useLinkTelegramStart',
  path: '/v1/rewards/telegram/link/start',
  method: 'POST',
  resolveUrl: (vars: LinkTelegramStartVars) => `/v1/rewards/telegram/link/start`,
  
  parseResponse: (raw: unknown): LinkTelegramStartResponse => raw as LinkTelegramStartResponse,
  
  
  
});
